var exports = {
  "kL": "x7f9a0e16--54d111--container",
  "n8": "x7f9a0e16--54d111--line",
  "hi": "x7f9a0e16--54d111--line-item",
  "DD": "x7f9a0e16--54d111--title",
};

module.exports = exports;
